var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vTable',{attrs:{"columns":_vm.columns,"data":_vm.data,"border":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }